import React, { useRef, useState } from 'react';
import { handleUpdateColor } from '../../../../../../DiscoveryBanner/colorToHex';
import { useOnClickOutside } from '../../../../../../../hooks/useOnClickOutside';
import { ColorPickerButton } from '../../../../../../DiscoveryBanner/DiscoveryBannerSettings.styles';
import {
  ChromePickerStyled,
  ColorBoxStyled,
  TextBoxStyled,
} from './EmailDisplaySettingsSection.styles';

interface Props {
  field: string;
  label: string;
  defaultColor: string;
  color: string;
  onChange: (field: string, value: any) => void;
  isLayout?: boolean;
}

export const ColorStyle = ({ field, label, defaultColor, color, onChange, isLayout }: Props) => {
  const [showColorPicker, setShowColorPicker] = useState(false);

  const colorRef = useRef(null);

  const handleColorChange = newColor => {
    if (!newColor) {
      onChange(field, defaultColor);
      return;
    }
    onChange(field, newColor);
  };

  useOnClickOutside(colorRef, () => {
    setShowColorPicker(false);
  });

  return (
    <ColorBoxStyled ref={colorRef}>
      <TextBoxStyled
        label={label}
        placeholder={defaultColor}
        value={color || defaultColor}
        fullWidth
        onChange={handleColorChange}
      >
        <ColorPickerButton
          type='button'
          aria-label={label}
          onClick={() => setShowColorPicker(!showColorPicker)}
          style={{ backgroundColor: color || defaultColor }}
        />

        {showColorPicker && (
          <ChromePickerStyled
            color={color}
            onChange={updatedColor => {
              handleUpdateColor(updatedColor, newColor => {
                handleColorChange(newColor);
              });
            }}
            isLayout={isLayout}
          />
        )}
      </TextBoxStyled>
    </ColorBoxStyled>
  );
};
